module.exports = __webpack_public_path__ + "img/banner_sub_programs.8fcd2b9b.png";